const validateNoSpecialChars = (rule, value, callback) => {
  if (!value) {
    callback();
    return;
  }
  // Allow only letters, numbers, spaces, hyphens, and apostrophes
  const specialCharPattern = /[^a-zA-Z0-9\s\-']/;
  if (specialCharPattern.test(value)) {
    callback(new Error('Special characters are not allowed'));
    return;
  }
  callback();
};

export const generateRules = function ($t) {
  return {
    firstName: [
      {required: true, message: $t('settings.accountRules.firstName'), trigger: 'blur'},
      {validator: validateNoSpecialChars, message: $t('settings.accountRules.noSpecialChars'), trigger: 'blur'},
    ],
    lastName: [
      {required: true, message: $t('settings.accountRules.lastName'), trigger: 'blur'},
      {validator: validateNoSpecialChars, message: $t('settings.accountRules.noSpecialChars'), trigger: 'blur'},
    ],
    email: [
      {required: true, type: 'email', message: $t('settings.accountRules.email'), trigger: 'blur'},
    ],
    appLoginName: [
      {required: true, message: $t('settings.accountRules.appLoginName'), trigger: 'blur'},
    ],
  }
};
